import { strings } from '../localization/strings';

interface PriceInfo {
  price?: number | null;
  priceOriginal?: number | null;
}

export const hasDiscount = (product: PriceInfo | null | undefined): boolean => {
  if (!product) return false;
  const { price, priceOriginal } = product;

  return !!(price && priceOriginal && Number(priceOriginal) > Number(price));
};

export const getDiscountPercentage = (product: PriceInfo | null | undefined): number | null => {
  if (!product) return null;
  const { price, priceOriginal } = product;

  const priceNum = Number(price);
  const priceOriginalNum = Number(priceOriginal);

  if (!priceNum || !priceOriginalNum || priceOriginalNum <= priceNum) return null;

  return Math.round(((priceOriginalNum - priceNum) / priceOriginalNum) * 100);
};

export const getDiscountBadge = (product: PriceInfo | null | undefined): string | null => {
  const percentage = getDiscountPercentage(product);

  if (!percentage) return null;

  return strings()?.badges?.blackFriday || `BLACK FRIDAY -${percentage}%`;
};
